import LinkMore from './LinkMore';

export default LinkMore;
